import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from "../day";
import figureFormatter from "@/services/utils/figureFormatter";
import { loadImageAsBase64 } from "@/services/utils/global";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  SulaimanLipi: {
    normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bold: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    italics: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bolditalics: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff'
  }
};

const printMushak67 = () => {
  const { formatDate } = useDate();
  const { commaFormat } = figureFormatter();

  const exportToPdfMushak67 = async (companyInfo, salesReturn) => {
    const imagePath = await loadImageAsBase64('/app-assets/images/gov_seal.png');

    const doc = {
      pageSize: "A4",
      pageOrientation: "portrait",
      pageMargins: [40, 40, 40, 30],
      defaultStyle: {
        font: "SulaimanLipi",
        fontSize: 9
      },
      content: getContent(companyInfo, salesReturn, imagePath),
      info: {
        title: 'মূসক-৬.৭'
      },
      styles: styles
    };

    pdfMake.createPdf(doc).open();
  }

  const getContent = (companyInfo, salesReturn, imagePath) => {
    return [
      getHeaderBlock(imagePath),
      { text: 'ক্রেডিট নোট', style: 'h2', margin: [0, 6, 0, 0] },
      { text: '[বিধি ৪০ এর উপ-বিধি (১) এর দফা (ছ) দ্রষ্টব্য]', style: 'small', margin: [0, 0, 0, 12] },
      getPartyBlock(companyInfo, salesReturn),
      { text: 'সরবরাহের বিবরণ', style: 'small', margin: [0, 10, 0, 4] },
      getItemTable(salesReturn),
      getReturnReasonBlock(salesReturn),
      getSignatureBlock(),
      getNoteBlock()
    ];
  }

  const getHeaderBlock = (imagePath) => {
    const seal = getSeal(imagePath);
    return {
      columns: [
        seal,
        {
          width: '*',
          stack: [
            { text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার', style: 'h1' },
            { text: 'জাতীয় রাজস্ব বোর্ড', style: 'h1', margin: [0, 3, 0, 0] }
          ]
        },
        {
          width: 55,
          margin: [0, 12, 0, 0],
          table: { widths: ['*'], body: [[{ text: 'মূসক-৬.৭', alignment: 'center', fontSize: 9 }]] },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        }
      ]
    };
  }

  const getSeal = (imagePath) => {
    if (! imagePath) return { width: 45, text: '' };
    return { image: imagePath, width: 45, height: 45 };
  }

  const getPartyBlock = (companyInfo, salesReturn) => {
    return {
      layout: 'noBorders',
      table: {
        widths: ['50%', '50%'],
        body: [
          [
            { text: 'ফেরত প্রদানকারী ব্যক্তির -', style: 'info' },
            { text: 'ফেরত গ্রহনকারী ব্যক্তির -', style: 'info' }
          ],
          [
            { text: 'নাম : ' + getContactField(salesReturn.contact, 'name'), style: 'info', margin: [0, 6, 0, 0] },
            { text: 'নাম : ' + getValue(companyInfo.name), style: 'info', margin: [0, 6, 0, 0] }
          ],
          [
            { text: 'বিআইএন: ' + getContactField(salesReturn.contact, 'bin_no'), style: 'info' },
            { text: 'বিআইএন: ' + getValue(companyInfo.vat_no), style: 'info' }
          ],
          [
            { text: 'মূল চালান নম্বর: ' + getSaleMasterField(salesReturn, 'bill_number'), style: 'info' },
            { text: 'ক্রেডিট নোট নম্বর: ' + getValue(salesReturn.bill_number), style: 'info' }
          ],
          [
            { text: 'মূল চালান ইস্যুর তারিখ : ' + getSaleMasterDate(salesReturn), style: 'info' },
            { text: 'ইস্যুর তারিখ : ' + getRowDate(salesReturn.date), style: 'info' }
          ],
          [
            { text: '', style: 'info' },
            { text: 'ইস্যুর সময় : ' + getValue(salesReturn.updated_at_time), style: 'info' }
          ]
        ]
      }
    };
  }

  const getItemTable = (salesReturn) => {
    return {
      table: {
        headerRows: 2,
        widths: [30, '*', 60, 55, 70, 75],
        body: getTableBody(salesReturn)
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => '#000',
        vLineColor: () => '#000',
        paddingLeft: () => 3,
        paddingRight: () => 3,
        paddingTop: () => 3,
        paddingBottom: () => 3
      }
    };
  }

  const getTableBody = (salesReturn) => {
    return [
      getTableHead(),
      getNumberRow(),
      ...getDataRows(salesReturn),
      ...getSummaryRows(salesReturn)
    ];
  }

  const getTableHead = () => {
    return [
      { text: 'ক্রমিক\nসংখ্যা', style: 'th' },
      { text: 'ফেরতপ্রাপ্ত সরবরাহের বিবরন', style: 'th' },
      { text: 'সরবরাহের একক', style: 'th' },
      { text: 'পরিমাণ', style: 'th' },
      { text: 'একক মূল্য ১ (টাকায়)', style: 'th' },
      { text: 'মোট মূল্য (টাকায়)', style: 'th' }
    ];
  }

  const getNumberRow = () => {
    const nums = ['(১)', '(২)', '(৩)', '(৪)', '(৫)', '(৬)'];
    return nums.map(function (n) {
      return { text: n, style: 'th' };
    });
  }

  const getLineItems = (salesReturn) => {
    if (! salesReturn) return [];
    if (! isEmptyList(salesReturn.general)) return salesReturn.general;
    if (! isEmptyList(salesReturn.ledgers)) return salesReturn.ledgers;
    return [];
  }

  const isEmptyList = (list) => {
    if (! list) return true;
    if (! Array.isArray(list)) return true;
    return list.length < 1;
  }

  const getDataRows = (salesReturn) => {
    const lineItems = getLineItems(salesReturn);
    if (! lineItems.length) return [getBlankRow()];
    return lineItems.map(function (item, index) {
      return mapRow(item, index);
    });
  }

  const mapRow = (item, index) => {
    const quantity = getNumber(item.quantity);
    const rate = getNumber(item.rate);
    return [
      { text: convertToBanglaNumber(index + 1), style: 'td' },
      { text: getLineDescription(item), style: 'tdLeft' },
      { text: getUnitName(item.product), style: 'td' },
      { text: commaFormat(quantity), style: 'tdRight' },
      { text: commaFormat(rate), style: 'tdRight' },
      { text: commaFormat(getLineAmount(item, quantity, rate)), style: 'tdRight' }
    ];
  }

  const getLineAmount = (item, quantity, rate) => {
    if (item.amount === undefined) return quantity * rate;
    if (item.amount === null) return quantity * rate;
    return getNumber(item.amount);
  }

  const getLineDescription = (item) => {
    if (item.product && item.product.name) return item.product.name;
    if (item.head && item.head.name) return item.head.name;
    if (item.description) return item.description;
    return '';
  }

  const getUnitName = (product) => {
    if (! product) return '';
    if (! product.description) return '';
    if (! product.description.unit) return '';
    if (! product.description.unit.name) return '';
    return product.description.unit.name;
  }

  const getBlankRow = () => {
    return Array.from({ length: 6 }, function () {
      return { text: ' ', style: 'td' };
    });
  }

  const getSummaryRows = (salesReturn) => {
    const rows = [
      ['মোট মূল্য', getNumber(salesReturn.subtotal_amount)],
      ['বাদ কর্তন ২', getNumber(salesReturn.total_discount)],
      ['মূসকসহ মূল্য', getNumber(salesReturn.total_amount)],
      ['মূসকের পরিমাণ', getNumber(salesReturn.vat_amount)],
      ['সম্পূরক শুল্কের পরিমাণ', 0],
      ['মোট কর ৩', getNumber(salesReturn.vat_amount)]
    ];
    return rows.map(function (row) {
      return mapSummaryRow(row[0], row[1]);
    });
  }

  const mapSummaryRow = (label, amount) => {
    return [
      { text: '', style: 'td', colSpan: 4 }, {}, {}, {},
      { text: label, style: 'tdLeft' },
      { text: commaFormat(amount), style: 'tdRight' }
    ];
  }

  const getReturnReasonBlock = (salesReturn) => {
    return {
      margin: [0, 12, 0, 0],
      stack: [
        { text: 'ফেরতের কারণ', style: 'info', margin: [0, 0, 0, 4] },
        {
          table: {
            widths: ['*'],
            body: [[{ text: getValue(salesReturn.description), style: 'tdLeft', margin: [2, 4, 2, 4] }]]
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#000',
            vLineColor: () => '#000'
          }
        }
      ]
    };
  }

  const getSignatureBlock = () => {
    return { text: 'দায়িত্বপ্রাপ্ত ব্যক্তির স্বাক্ষর', style: 'info', margin: [0, 25, 0, 0] };
  }

  const getNoteBlock = () => {
    return {
      margin: [0, 25, 0, 0],
      stack: [
        { text: '১ প্রতি একক পণ্য / সেবার মূসক ও সম্পূরক শুল্ক সহ মূল্য ।', style: 'footerNote' },
        { text: '২ ফেরত প্রদানের জন্য কোনো কর্তন থাকইলে উহার পরিমাণ ।', style: 'footerNote' },
        { text: '৩ মূসক ও সম্পূরক শুল্কের যোগফল ।', style: 'footerNote' },
        {
          text: '১ এসআরও নং-১৫৯ - আইন / ২০১৭/ ০২- মূসক, তারিখ: ১ জুন , ২০১৭ দ্বারা প্রতিস্থাপিত।',
          style: 'footerNote',
          margin: [0, 15, 0, 0]
        }
      ]
    };
  }

  const getContactField = (contact, field) => {
    if (! contact) return '';
    if (! contact[field]) return '';
    return contact[field];
  }

  const getSaleMasterField = (salesReturn, field) => {
    if (! salesReturn.sale_master) return '';
    if (! salesReturn.sale_master[field]) return '';
    return salesReturn.sale_master[field];
  }

  const getSaleMasterDate = (salesReturn) => {
    return getRowDate(getSaleMasterField(salesReturn, 'date'));
  }

  const getRowDate = (date) => {
    if (! date) return '';
    return formatDate(new Date(date)).split(' ')[0];
  }

  const getValue = (value) => {
    if (! value) return '';
    return value;
  }

  const getNumber = (value) => {
    const parsed = parseFloat(value);
    if (isNaN(parsed)) return 0;
    return parsed;
  }

  const convertToBanglaNumber = (number) => {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return number.toString().split('').map(function (d) {
      return banglaDigits[d] || d;
    }).join('');
  }

  const styles = {
    h1: { fontSize: 12, alignment: 'center' },
    h2: { fontSize: 11, alignment: 'center' },
    small: { fontSize: 9, alignment: 'center' },
    info: { fontSize: 9, alignment: 'left' },
    th: { fontSize: 8, alignment: 'center', lineHeight: 1.1 },
    td: { fontSize: 8, alignment: 'center' },
    tdRight: { fontSize: 8, alignment: 'right' },
    tdLeft: { fontSize: 8, alignment: 'left' },
    footerNote: { fontSize: 8 }
  };

  return {
    exportToPdfMushak67
  }
}

export default printMushak67;
